import axios from 'axios'

export default {
  getDash(){
    return axios.get(`/dash/admin`)
  }
}
